import classNames from 'classnames';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { userStatusService } from './domain';
import { classroomJoinedState } from './domain/services/ClassroomJoinedState';
import { ModalMessageComponent } from './lib/components/modal/ModalMessageComponent';
import { mainNavRef } from './pages/block-references';
import { ContentBlock } from './pages/ContentBlock';
import { HeaderBlock } from './pages/HeaderBlock';
import { LogoBlock } from './pages/LogoBlock';
import { SidebarBlock } from './scenes/sidebar/SidebarBlock';
import { Helmet } from 'react-helmet';

@observer
class Root extends React.Component {

  @observable
  sidebarMinimized: boolean;

  constructor(props: any) {
    super(props);
    makeObservable(this);
    this.sidebarMinimized = false;
    (window as any).Tilzone = {};
  }

  componentDidMount() {
    userStatusService.refreshWhoAmI();
  }

  render() {
    let status = userStatusService.status;

    const isLoggedIn = status.isLoggedIn;
    let showSidebar: boolean;
    let showHeader: boolean;
    let showFooter: boolean;
    showSidebar = showHeader = showFooter = isLoggedIn;

    const isInClassroom = classroomJoinedState.joined;
    const rootClass = classNames({
      'app-layout-root': true,
      'sidebar-minimized': this.sidebarMinimized,
      'sidebar-expanded': !this.sidebarMinimized,
      'in-classroom': isInClassroom,
      'classroom-teacher': isInClassroom && classroomJoinedState.role === 'Teacher',
      'classroom-student': isInClassroom && classroomJoinedState.role === 'Student'
    });


    const mainContainerClass = classNames({
      'main-container': true,
      welcome: !isLoggedIn,
    });
    return (
      <div className={rootClass}>

        <div className={mainContainerClass} key="main-container">
          {
            showHeader &&
            <div className="main-top" key="header">
              <div className="header-content">
                <LogoBlock />
              </div>
              <div className="app-header">
                <HeaderBlock />
              </div>
            </div>
          }
          <div className="main-nav" ref={mainNavRef} key="sidebar">
            {
              showSidebar &&
              <SidebarBlock />
            }
          </div>

          <div className="main-content" key="main-content">
            <div className="app-content" key="app-content">
              <ContentBlock />
            </div>
            {
              showFooter &&
              <div className="app-footer" key="footer">
                <div className="footer-content">
                  © Copyright Tilzone | All Rights Reserved 2023.
                </div>
              </div>
            }
          </div>

        </div>

        <ModalMessageComponent />
        <div className='intercom'>
          <Helmet>
            <script>
{`// We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/b8w4ohh8'
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/b8w4ohh8';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
`}
            </script>
          </Helmet>
        </div>
      </div>
    );
  }
}

export default Root;
